import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import { useAtom } from 'jotai';
import React, { useState } from 'react';
import { Dimensions, ScrollView, Text } from 'react-native';
import styled from 'styled-components/native';
import InfoIcon from '@/assets/icon/ic_info.svg';
import PositionedModal from '@/components/PositionedModal';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { useExperimentVariant } from '@/hooks/useExperiment';
import BottomSheet from '@/modals/BottomSheet';
import { SortOption, filterAtom, filterModalStateAtom, } from '@/screens/SearchScreen/atoms';
import ChipSelector from '@/screens/SearchScreen/modals/ChipSelector';
import ScoreSelector from '@/screens/SearchScreen/modals/ScoreSelector.tsx';
const { height } = Dimensions.get('window');
// TODO: 가까운 순 선택 시 위치권한이 없으면 설정으로 이동하는 BottomSheet 를 보여준다.
export default function FilterModal() {
    const [savedFilter, setSavedFilter] = useAtom(filterAtom);
    const [state, setFilterModalState] = useAtom(filterModalStateAtom);
    const [draftSortOption, setDraftSortOption] = useState();
    const [draftHasSlope, setDraftHasSlope] = useState();
    const [draftScoreUnder, setDraftScoreUnder] = useState();
    const [draftIsRegistered, setDraftIsRegistered] = useState();
    const [draftHasReview, setDraftHasReview] = useState();
    const isHasReviewEnabled = useExperimentVariant('HAS_REVIEW_FILTER') !== 'CONTROL';
    const sortOption = draftSortOption === undefined ? savedFilter.sortOption : draftSortOption;
    const hasSlope = draftHasSlope === undefined ? savedFilter.hasSlope : draftHasSlope;
    const scoreUnder = draftScoreUnder === undefined ? savedFilter.scoreUnder : draftScoreUnder;
    const isRegistered = draftIsRegistered === undefined
        ? savedFilter.isRegistered
        : draftIsRegistered;
    const hasReview = draftHasReview === undefined ? savedFilter.hasReview : draftHasReview;
    const saveFilter = () => {
        setSavedFilter({ sortOption, hasSlope, scoreUnder, isRegistered, hasReview });
        setFilterModalState(null);
    };
    const reset = () => {
        setDraftSortOption(undefined);
        setDraftHasSlope(undefined);
        setDraftScoreUnder(undefined);
        setDraftIsRegistered(undefined);
        setDraftHasReview(undefined);
        const defaults = {
            sortOption: SortOption.LOW_SCORE,
            hasSlope: null,
            scoreUnder: null,
            isRegistered: null,
            hasReview: null,
        };
        setSavedFilter(defaults);
    };
    return (_jsxs(BottomSheet, { isVisible: state !== null, onPressBackground: () => {
            setFilterModalState(null);
        }, children: [_jsxs(ScrollView, { bounces: false, style: {
                    maxHeight: (height * 80) / 100,
                }, contentContainerStyle: {
                    gap: 36,
                    paddingVertical: 24,
                    paddingHorizontal: 20,
                }, showsVerticalScrollIndicator: false, children: [(state === 'All' || state === 'sortOption') && (_jsxs(FilterItem, { children: [_jsx(FilterLabel, { children: "\uC815\uB82C" }), _jsx(ChipSelector, { items: [
                                    {
                                        label: '가까운 순',
                                        option: SortOption.DISTANCE,
                                        isSelected: sortOption === SortOption.DISTANCE,
                                    },
                                    {
                                        label: '정확도 순',
                                        option: SortOption.ACCURACY,
                                        isSelected: sortOption === SortOption.ACCURACY,
                                    },
                                    {
                                        label: '접근레벨 낮은 순',
                                        option: SortOption.LOW_SCORE,
                                        isSelected: sortOption === SortOption.LOW_SCORE,
                                    },
                                ], onPress: option => {
                                    setDraftSortOption(option);
                                } })] })), (state === 'All' || state === 'scoreUnder') && (_jsx(_Fragment, { children: _jsxs(FilterItem, { children: [_jsxs(LabelIconArea, { children: [_jsx(FilterLabel, { children: "\uC811\uADFC\uB808\uBCA8" }), _jsx(PositionedModal, { modalContent: _jsx(Text, { style: {
                                                    fontSize: 12,
                                                    fontFamily: font.pretendardMedium,
                                                    color: color.white,
                                                }, children: "\uB808\uBCA8\uC774 \uB0AE\uC744 \uC218\uB85D \uB9E4\uC7A5 \uC785\uAD6C \uC811\uADFC\uC774 \uC26C\uC6CC\uC694." }), children: _jsx(InfoIcon, { width: 16, height: 16, color: color.gray30 }) })] }), _jsx(ScoreSelector, { score: scoreUnder, onChange: score => {
                                        setDraftScoreUnder(score);
                                    } })] }) })), (state === 'All' || state === 'hasSlope') && (_jsxs(FilterItem, { children: [_jsx(FilterLabel, { children: "\uACBD\uC0AC\uB85C \uC720\uBB34" }), _jsx(ChipSelector, { items: [
                                    {
                                        label: '전체',
                                        option: null,
                                        isSelected: hasSlope === null,
                                    },
                                    {
                                        label: '경사로 있음',
                                        option: true,
                                        isSelected: hasSlope === true,
                                    },
                                    {
                                        label: '경사로 없음',
                                        option: false,
                                        isSelected: hasSlope === false,
                                    },
                                ], onPress: option => {
                                    setDraftHasSlope(option);
                                    setDraftHasSlope(option);
                                } })] })), (state === 'All' || state === 'isRegistered') && (_jsxs(FilterItem, { children: [_jsx(FilterLabel, { children: "\uC815\uBCF5 \uC5EC\uBD80" }), _jsx(ChipSelector, { items: [
                                    {
                                        label: '전체',
                                        option: null,
                                        isSelected: isRegistered === null,
                                    },
                                    {
                                        label: '정복완료만 보기',
                                        option: true,
                                        isSelected: isRegistered === true,
                                    },
                                    {
                                        label: '정복 안 된 곳만 보기',
                                        option: false,
                                        isSelected: isRegistered === false,
                                    },
                                ], onPress: option => {
                                    setDraftIsRegistered(option);
                                } })] })), isHasReviewEnabled && (state === 'All' || state === 'hasReview') && (_jsxs(FilterItem, { children: [_jsx(FilterLabel, { children: "\uB9AC\uBDF0 \uC720\uBB34" }), _jsx(ChipSelector, { items: [
                                    {
                                        label: '전체',
                                        option: null,
                                        isSelected: hasReview === null,
                                    },
                                    {
                                        label: '리뷰 있는 곳만',
                                        option: true,
                                        isSelected: hasReview === true,
                                    },
                                ], onPress: option => {
                                    setDraftHasReview(option);
                                } })] }))] }), _jsx(Divider, {}), _jsxs(ButtonBox, { children: [state === 'All' && (_jsx(SccButton, { text: '초기화', textColor: "black", buttonColor: "white", borderColor: "gray20", fontFamily: font.pretendardMedium, style: { flexGrow: 0, paddingHorizontal: 20 }, onPress: () => {
                            reset();
                        }, elementName: "search_filter_reset" })), _jsx(SccButton, { text: '결과보기', textColor: "white", buttonColor: "brandColor", fontFamily: font.pretendardMedium, style: { flexGrow: 1 }, onPress: () => {
                            saveFilter();
                        }, elementName: "search_filter_apply" })] })] }));
}
const ButtonBox = styled.View `
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
const FilterItem = styled.View `
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;
const FilterLabel = styled.Text `
  font-size: 16px;
  font-family: ${() => font.pretendardBold};
  color: ${() => color.black};
`;
const Divider = styled.View `
  width: 100%;
  height: 1px;
  background-color: ${() => color.gray20};
`;
const LabelIconArea = styled.View `
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
